<template>
    <div class="card" :class="{active:active}" @click="$emit('select')">
        <div class="delete" v-if="canDelete" @click.stop.prevent="remove(item)">
            <i class="fas fa-trash"></i>
        </div>
        <div class="image">
            <img :src="item.getThumbnail()" alt="">
        </div>
        <div class="icon" v-if="showType">
            <tooltip :text="$t(item.getLabelObject())" position="right">
                <i class="fal" :class="item.getIconObject()"></i>
            </tooltip>
        </div>
        <div class="text">
            <div v-if="showType" class="type">{{item.getLabelObject()}}</div>
            {{ item.getName()|subStr}}
        </div>
    </div>
</template>

<script>
import Tooltip from "@/modules/tooltip";
export default {
    name: "card",
    components: {Tooltip},
    props:{
        item:Object,
        canDelete:Boolean,
        showType:Boolean,
        active:Boolean
    },
    methods:{
        remove(item){
            return this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('Confirm'),
                text: this.$t("Do you really want to remove this "+this.$t(item.objectType)+" ?"),
                acceptText:this.$t('Yes, remove it'),
                cancelText:this.$t('No'),
                accept: () => {
                    this.$emit("remove",item)
                }
            })
        }
    },
    filters: {
        subStr: function(string) {
            if(string.length > 33) {
                return string.substring(0, 30) + '...';
            }
            return string;
        }
    },
}
</script>